import { useState } from 'react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Field, Input, Select } from '@/components/ui/input';
import { EditLockBanner } from '@/components/ui/edit-lock-banner';
import { useEditLock } from '@/hooks/useEditLock';

/**
 * Edición en línea de una familia, con el bloqueo de edición del registro.
 *
 * Van juntos a propósito: los campos y el cableado del bloqueo, para que editar una familia no se
 * pueda quedar sin protección al copiar el formulario. Los botones viven **fuera** del `fieldset`
 * deshabilitado: si no, en solo lectura no habría forma de «Continuar editando aquí».
 */
export function FamiliaEditRow({ familia, opcionesPadre, guardando, onGuardar, onCancelar }: {
  familia: { id: string; name: string; parentId: string };
  opcionesPadre: { id: string; name: string }[];
  guardando: boolean;
  onGuardar: (datos: { name: string; parentId: string }) => void;
  onCancelar: () => void;
}) {
  const bloqueo = useEditLock('family', familia.id);
  const soloLectura = !bloqueo.canEdit;
  const [name, setName] = useState(familia.name);
  const [parentId, setParentId] = useState(familia.parentId);

  return (
    <div className="space-y-2">
      <EditLockBanner
        state={bloqueo.state}
        onTakeOver={() => void bloqueo.takeOver()}
        onRetry={() => void bloqueo.retry()}
      />
      <div className="grid gap-2 sm:grid-cols-4">
      <fieldset disabled={soloLectura} className="m-0 contents min-w-0 border-0 p-0">
        <Field label="Nombre" className="sm:col-span-2">
          <Input value={name} onChange={(e) => setName(e.target.value)} />
        </Field>
        <Field label="Depende de">
          <Select value={parentId} onChange={(e) => setParentId(e.target.value)}>
            <option value="">Sin familia padre</option>
            {opcionesPadre.map((otra) => <option key={otra.id} value={otra.id}>{otra.name}</option>)}
          </Select>
        </Field>
        <div className="flex items-end gap-2">
          <Button size="sm" loading={guardando} onClick={() => onGuardar({ name, parentId })}>Guardar</Button>
        </div>
      </fieldset>
      {/* Cancelar siempre activo: en solo lectura hay que poder salir. */}
      <div className="flex items-end">
        <Button size="sm" variant="ghost" onClick={onCancelar}>Cancelar</Button>
      </div>
      </div>
    </div>
  );
}
